const url = "https://vpic.nhtsa.dot.gov/api/vehicles";

export default url;
